<br>
<div class="col-lg-12">
  <h4 style="text-align: center;">SINOMYT - SISTEMA DE NOMINAS Y TRANSFERENCIAS (WEB)</h4>
  <br>
  <div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="option" [(ngModel)]="option" value="GENERAL" selected>
      <label class="form-check-label" for="inlineRadio1">GENERAL</label>
    </div>
    <div (click)="dataSourceOpe = [];" class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="option" [(ngModel)]="option" value="EMPRESA">
      <label class="form-check-label" for="inlineRadio2">POR EMPRESA</label>
    </div>
  <div>
    <label *ngIf="option == 'EMPRESA'" for="cuit">CUIT:</label>&nbsp;
    <app-cuit-input *ngIf="option == 'EMPRESA'" [(ngModel)]="filtroCUIT" name="filtroCUIT" inputStyle="width: 115px;"></app-cuit-input>
    &nbsp;
    <label for="cuit">PERI DESDE:</label>&nbsp;
    <input maxlength="5" style="width: 60px;" type="text" name="filtropdesde" [(ngModel)]="filtropdesde">
    &nbsp;
    <label for="cuit">PERI HASTA:</label>&nbsp;
    <input  maxlength="5" style="width: 60px;" type="text" name="filtrophasta" [(ngModel)]="filtrophasta">
    &nbsp;
    <button [disabled]="(filtropdesde.lenght <=4) || (filtrophasta.length <=4)" 
            type="button" class="btn btn-primary" 
            (click)="cargarGrid()">
       <span *ngIf="loading==false">CONSULTAR</span>
       <span *ngIf="loading==true">PROCESANDO DATOS..</span> 
       <i *ngIf="loading" class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
    </button>
    &nbsp;

    <button [disabled] = "apagar==true" type="button" class="btn btn-success" (click)="exportAsExcelReporte()">
      <i class="fa fa-plane" aria-hidden="true"></i>
      &nbsp;
      <span>EXPORTAR A EXCEL</span>
    </button>

    <button data-toggle="modal" data-target="#MODALFECREC" type="button" class="btn btn-secondary">
      <i class="fa fa-gg-circle" aria-hidden="true"></i>
      &nbsp;
      <span>GENERAR POR FECHA-RECAUDACION</span>
    </button>

  </div>
  
  <hr>
  <div *ngIf="dataSourceOpe != null" class="animated fadeIn">
    <table *ngIf="option === 'GENERAL'" mat-table [dataSource]="dataSourceOpeTotal" class="mat-elevation-z8 animated fadeIn">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                        [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)"
                        [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>
    
      <!-- Name Column -->
      <ng-container matColumnDef="CUIT">
        <th mat-header-cell *matHeaderCellDef> CUIT </th>
        <td mat-cell *matCellDef="let element"> {{element.CUIT}} </td>
      </ng-container>
    
      <!-- Weight Column -->
      <ng-container matColumnDef="RAZON_SOCIAL">
        <th mat-header-cell *matHeaderCellDef> RAZON SOCIAL </th>
        <td mat-cell *matCellDef="let element"> {{element.RAZON_SOCIAL}} </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="DESDE">
        <th mat-header-cell *matHeaderCellDef> PERI_DESDE </th>
        <td mat-cell *matCellDef="let element"> {{element.DESDE}} </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="HASTA">
        <th mat-header-cell *matHeaderCellDef> PERI_HASTA </th>
        <td mat-cell *matCellDef="let element"> {{element.HASTA}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="REMOSIMP">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> REMOSIMP</th>
        <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.REMOSIMP | currency:"$"}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="DDJJ_APORTE">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> DDJJ_APORTE</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.DDJJ_APORTE | currency:"$"}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="DDJJ_CONTRIB">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> DDJJ_CONTRIB</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.DDJJ_CONTRIB | currency:"$"}} </td>
      </ng-container>
      
      <!-- Symbol Column -->
      <ng-container matColumnDef="DEUDA_NOM">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> DEUDA_NOM</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.DEUDA_NOM | currency:"$"}} </td>
      </ng-container>
      
      <!-- Symbol Column -->
      <ng-container matColumnDef="Transf_C">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> Transf_C</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.Transf_C | currency:"$"}} </td>
      </ng-container>
      
      <!-- Symbol Column -->
      <ng-container matColumnDef="Transf_D">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> Transf_D</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.Transf_D | currency:"$"}} </td>
      </ng-container>
      
      <!-- Symbol Column -->
      <ng-container matColumnDef="Transferido">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> Transferido</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.Transferido | currency:"$"}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="SALDO">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> SALDO A RECAUDAR</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.SALDO | currency:"$"}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          (click)="selection.toggle(row)">
      </tr>
    </table>

    <table *ngIf="option === 'EMPRESA'"  mat-table [dataSource]="dataSourceOpe" class="mat-elevation-z8 animated fadeIn">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                        [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)"
                        [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>
    
      <!-- Name Column -->
      <ng-container matColumnDef="CUIT">
        <th mat-header-cell *matHeaderCellDef> CUIT </th>
        <td mat-cell *matCellDef="let element"> {{element.CUIT}} </td>
      </ng-container>
    
      <!-- Weight Column -->
      <ng-container matColumnDef="RAZON_SOCIAL">
        <th mat-header-cell *matHeaderCellDef> RAZON SOCIAL </th>
        <td mat-cell *matCellDef="let element"> {{element.RAZON_SOCIAL}} </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="DESDE">
        <th mat-header-cell *matHeaderCellDef> PERI_DESDE </th>
        <td mat-cell *matCellDef="let element"> {{element.DESDE}} </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="HASTA">
        <th mat-header-cell *matHeaderCellDef> PERI_HASTA </th>
        <td mat-cell *matCellDef="let element"> {{element.HASTA}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="REMOSIMP">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> REMOSIMP</th>
        <td mat-cell *matCellDef="let element" style="text-align: center;"> {{element.REMOSIMP | currency:"$"}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="DDJJ_APORTE">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> DDJJ_APORTE</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.DDJJ_APORTE | currency:"$"}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="DDJJ_CONTRIB">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> DDJJ_CONTRIB</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.DDJJ_CONTRIB | currency:"$"}} </td>
      </ng-container>
      
      <!-- Symbol Column -->
      <ng-container matColumnDef="DEUDA_NOM">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> DEUDA_NOM</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.DEUDA_NOM | currency:"$"}} </td>
      </ng-container>
      
      <!-- Symbol Column -->
      <ng-container matColumnDef="Transf_C">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> Transf_C</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.Transf_C | currency:"$"}} </td>
      </ng-container>
      
      <!-- Symbol Column -->
      <ng-container matColumnDef="Transf_D">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> Transf_D</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.Transf_D | currency:"$"}} </td>
      </ng-container>
      
      <!-- Symbol Column -->
      <ng-container matColumnDef="Transferido">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> Transferido</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.Transferido | currency:"$"}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="SALDO">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> SALDO A RECAUDAR</th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.SALDO | currency:"$"}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          (click)="selection.toggle(row)">
      </tr>
    </table>

  </div>
  <hr>
</div>


<!-- Modal REPORTE -->
<div style="margin-top: 100px" class="modal fade" id="MODALDATOS" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div id="modito" class="modal-content">
          <div [class]="modalessHeader">
              GENERAR REPORTE POR FECHA DE RECAUDACION
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body" #REPORTE>
            <label for="aa">FECHA RECAUDACION DESDE</label>
            <input [(ngModel)]="filtrofrecdes" name="filtrofrecdes" type="text" class="form-control">
            <label for="s">FECHA RECAUDACION HASTA</label>
            <input [(ngModel)]="filtrofrechas" name="filtrofrechas" type="text" class="form-control">       
          </div>
          <button type="button" class="btn btn-success" (click)="generarFecrec()" ><span *ngIf="!loading2">GENERAR REPORTE</span><span *ngIf="loading2">Generando, por favor espere.. <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i></span></button>
          <button id="salemodal" type="button" class="btn btn-info" data-dismiss="modal">VOLVER></button>
      </div>
  </div>
</div>

  <!-- modal fecrec large -->
<div style="margin-top: 80px;" class="modal fade bd-example-modal-lg" id="MODALFECREC" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg bg-dark">
    <div class="modal-content bg-dark">
      <div class="modal-body">                        
        <label style="color: white;" for="aa">FECHA RECAUDACION DESDE</label>
        <input [(ngModel)]="filtrofrecdes" name="filtrofrecdes" type="text" class="form-control">
        <label style="color: white;" for="s">FECHA RECAUDACION HASTA</label>
        <input [(ngModel)]="filtrofrechas" name="filtrofrechas" type="text" class="form-control">       
        <hr>
        <button [disabled]="loading3" type="button" class="btn btn-success" (click)="generarFecrec()" ><span *ngIf="!loading2">GENERAR POR AGENTE DE RETENCION</span><span *ngIf="loading2">Generando, por favor espere.. <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i></span></button>
        <button [disabled]="loading2" type="button" class="btn btn-secondary" (click)="generarFecrecBeneficiario()" ><span *ngIf="!loading3">GENERAR POR BENEFICIARIO</span><span *ngIf="loading3">Generando, por favor espere.. <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i></span></button>
        <button [disabled]="loading3 || loading2" id="salemodal" type="button" class="btn btn-dark" data-dismiss="modal">VOLVER</button>
      </div>
    </div>
  </div>
</div>
